uniform float uSize;
uniform float uTime;

attribute float aScale;
attribute float aRandomness;

void main(){
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    float maxY = 1.35;
    float resetY = 0.65;
    modelPosition.y += uTime * aRandomness * 0.06;
    modelPosition.y = mod(modelPosition.y - resetY, maxY - resetY) + resetY;

    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;
    gl_PointSize = uSize * aScale;
    gl_PointSize *= (1.0 / -viewPosition.z);

}